var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsfactoryFulllogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242.927,
    height: 73,
    viewBox: "0 0 242.927 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M0,0H29.385L20.313,10.144,17.441,20.522,25.4,28.35l-5.087,4.374H0Z",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(-48 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(48 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(13.094 16.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M5550.208,12014.562h0l19.658-32.8,18.713,32.229h-18.447l1.887-3.291,2.014-3.513",
    transform: "translate(-5546.565 -11981.765)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_199",
    "data-name": "Path 199",
    transform: "translate(9.939 34.539) rotate(-60)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.66501045227051 3.997086048126221 L 2.718241691589355 3.708148002624512 L 0.8788952231407166 0.5222964882850647 L 20.9254035949707 1.02719509601593 L 19.66501045227051 3.997086048126221 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.757801055908203 1.044589996337891 L 3.009765625 3.213052749633789 L 19.33645057678223 3.491418838500977 L 20.17797088623047 1.508527040481567 L 1.757801055908203 1.044589996337891 M 3.814697265625e-06 3.337860107421875e-06 L 21.67284202575684 0.5458633899688721 L 19.99357223510742 4.502763271331787 L 2.426752090454102 4.203253269195557 L 3.814697265625e-06 3.337860107421875e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_201",
    "data-name": "Path 201",
    transform: "translate(19.807 34.21) rotate(-60)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.58235454559326 19.18978881835938 L 0.8679193258285522 0.6602208018302917 L 12.3278169631958 0.6881147027015686 L 11.10793590545654 3.496381998062134 L 6.561892509460449 3.460875272750854 L 5.841252326965332 3.45524525642395 L 6.088272571563721 4.132235527038574 L 11.58235454559326 19.18978881835938 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.735820770263672 1.162326812744141 L 9.152229309082031 13.98829078674316 L 5.124522686004639 2.949615478515625 L 10.78111457824707 2.993806838989258 L 11.56629180908203 1.186262130737305 L 1.735820770263672 1.162326812744141 M 2.86102294921875e-06 0.1580944061279297 L 13.08934211730957 0.1899662017822266 L 11.43476295471191 3.998945236206055 L 6.557982444763184 3.960845947265625 L 12.95026206970215 21.4800853729248 L 12.6597728729248 22.05194473266602 L 2.86102294921875e-06 0.1580944061279297 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_200",
    "data-name": "Path 200",
    transform: "translate(0 34.507) rotate(-60)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.30502891540527 3.777385711669922 L 2.611890554428101 3.523930549621582 L 1.147428154945374 0.9874031543731689 L 20.76625823974609 1.357275366783142 L 21.30502891540527 3.777385711669922 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.023025512695312 1.503998756408691 L 2.902809143066406 3.027822971343994 L 20.67957305908203 3.268853664398193 L 20.3636589050293 1.849772930145264 L 2.023025512695312 1.503998756408691 M 0.2718143463134766 0.4708080291748047 L 21.16885566711426 0.8647778034210205 L 21.93046569824219 4.285907745361328 L 2.320964813232422 4.020028114318848 L 0.2718143463134766 0.4708080291748047 Z",
    stroke: "none",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "APPS",
    transform: "translate(135 27)",
    fill: "#fff",
    fontSize: 28,
    fontFamily: "Gilroy-Light, Gilroy",
    fontWeight: 300,
    letterSpacing: "0.071em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "APPS")), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(134.845 37.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(0 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M926.676-171.942v-13.925h16.677v4.6H930.807v9.329Z",
    transform: "translate(-926.676 197.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M926.676-203.98l4.258,4.258H943.36v-4.258Z",
    transform: "translate(-926.676 203.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608",
    transform: "translate(17.438 2.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M958.4-178.718l12.9-25.367,8.363,17.029h-4.837L971.3-194.11l-7.507,15.392Z",
    transform: "translate(-958.398 204.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M986.3-171.468h4.961l1.9,3.6H988.2Z",
    transform: "translate(-967.761 193.251)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M1031.972-178.822v-25.317h12.594v4.5h-8.417v20.815Z",
    transform: "translate(-964.271 206.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "translate(83.165 2.671)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.689,
    cy: 12.689,
    r: 12.689,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.689,
    cy: 12.689,
    r: 10.689,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M1137.523-203.98h4.976l7.137,9.224,6.809-9.224h4.911v1.564L1142.5-178.65h-4.976l9.886-12.7Z",
    transform: "translate(-1005.273 206.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(40.029)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15948",
    "data-name": "Path 15948",
    transform: "translate(4.007 2.671)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.689,0A12.689,12.689,0,1,1,0,12.689,12.689,12.689,0,0,1,12.689,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.68895149230957 4.000001907348633 C 7.897851943969727 4.000001907348633 4.000001907348633 7.897851943969727 4.000001907348633 12.68895149230957 C 4.000001907348633 17.48005104064941 7.897851943969727 21.37790107727051 12.68895149230957 21.37790107727051 C 17.48005104064941 21.37790107727051 21.37790107727051 17.48005104064941 21.37790107727051 12.68895149230957 C 21.37790107727051 7.897851943969727 17.48005104064941 4.000001907348633 12.68895149230957 4.000001907348633 M 12.68895149230957 1.9073486328125e-06 C 19.69687080383301 1.9073486328125e-06 25.37790107727051 5.681041717529297 25.37790107727051 12.68895149230957 C 25.37790107727051 19.69687080383301 19.69687080383301 25.37790107727051 12.68895149230957 25.37790107727051 C 5.681041717529297 25.37790107727051 1.9073486328125e-06 19.69687080383301 1.9073486328125e-06 12.68895149230957 C 1.9073486328125e-06 5.681041717529297 5.681041717529297 1.9073486328125e-06 12.68895149230957 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M1100.838-204l2.907,4.257H1114.1c3.071.079,6.61,9.194-5.629,8.449v1.473l7.17,11.239h5.271l-6.007-9.34s5.813-1.434,6.007-7.209-3.263-9.011-9.156-8.869Z",
    transform: "translate(-991.541 206.674)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsfactoryFulllogo);
export default __webpack_public_path__ + "static/media/appsfactory-fulllogo.17b1ae1f85c637969fe23d9d6bf12cf1.svg";
export { ForwardRef as ReactComponent };